import type { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

export const RundownLoadingOverlay: FC = () => {
  return (
    <div className="relative w-full h-96 flex items-center justify-center">
      <div className="flex flex-col items-center gap-5 max-w-md text-center">
        <FontAwesomeIcon icon={faSpinner} className="animate-spin text-2xl" />
        <span className="text-xl">Rundown is loading...</span>
        <p className="text-sm text-gray-500 mt-2">
          Large rundowns may load slowly. We recently removed a performance
          optimization that was causing critical issues during live shows.
          We&apos;re actively working on a solution to restore fast loading for
          large rundowns.
        </p>
      </div>
    </div>
  )
}
